(function () {
  const HOME = {
    1: [434, -12, 128, 170, 1],
    2: [1018, 176, 300, 400, 1],
    3: [85, 200, 300, 400, 1],
    4: [-28, -69, 112, 149, 1],
    5: [1002, 633, 114, 153, 0.5],
    6: [109, 576, 100, 133, 0.5],
    7: [1252, 35, 92, 123, 0.7],
    8: [375, 735, 123, 165, 1],
    9: [1298, 786, 123, 165, 0.5],
  };
  const SHADOW = new Set([2, 3, 5, 8, 9]);

  const ORDER = [1, 9, 3, 7, 5, 2, 8, 4, 6];
  const FIRST = 0.04;
  const STEP = 0.075;
  const SLOT_LEN = 0.3;
  const K_OUT = 2.2;
  const SCALE_OUT = 1.5;
  const SCROLL_ROOM = 1800;
  const SCRUB = 0.8;

  const TEXT_STEPS = {
    h1In: [0, 0.25],
    descIn: [1 / 3, 1 / 6],
    oldOut: [0.68, 0.14],
    bigMove: [0.82, 0.02],
    bigIn: [0.84, 0.16],
  };

  const M_HOME = {
    1: [19, -20, 34, 45, 1],
    2: [314, 0, 52, 71, 1],
    3: [154, 597, 55.16, 74, 1],
    4: [259, 126, 110, 148, 1],
    5: [12, 410, 121, 161, 1],
    6: [328, 433, 62, 83, 1],
    7: [19, 87, 54, 72, 1],
  };

  const TIERS = [
    { query: '(min-width: 990px) and (prefers-reduced-motion: no-preference)', figW: 1440, figH: 828, home: HOME, textW: 596, room: SCROLL_ROOM, introAll: true },
    { query: '(max-width: 989px) and (prefers-reduced-motion: no-preference)', figW: 390, figH: 662, home: M_HOME, textW: 370,
      room: 2500, exitX: 1.34, yDamp: 0.4, first: 0.02, step: 0.135, slot: 0.18,
      cardW: 180 / 390, cardH: 200 / 390 },
  ];

  let cleanup = null;

  function init() {
    cleanup?.();
    cleanup = null;
    const root = document.getElementById('DrvLearnHero');
    if (!root || !window.gsap || !window.ScrollTrigger) return;
    gsap.registerPlugin(ScrollTrigger);

    const mm = gsap.matchMedia();
    TIERS.forEach((T) => mm.add(T.query, () => {
      root.classList.add('drv-lhero--anim');
      const pin = root.querySelector('.drv-lhero__pin');
      const stage = root.querySelector('.drv-lhero__stage');
      const text = root.querySelector('.drv-lhero__text');
      const layers = {};
      root.querySelectorAll('[data-drv-lhero-layer]').forEach((el) => (layers[el.dataset.drvLheroLayer] = el));
      const cards = {};
      root.querySelectorAll('[data-drv-lhero-card]').forEach((el) => {
        const i = +el.dataset.drvLheroCard;
        if (!T.home[i]) return;
        cards[i] = el;
        if (SHADOW.has(i)) el.classList.add('drv-lhero__card--shadow');
      });

      let SW = 0, SH = 0, SF = 1;
      const dims = (i) => (T.cardW ? [T.cardW * SW, T.cardH * SW] : [T.home[i][2] * SF, T.home[i][3] * SF]);
      const sizeCards = () => {
        SW = stage.clientWidth;
        SH = stage.clientHeight;
        SF = SW / T.figW;
        for (const [i, el] of Object.entries(cards)) {
          const [w, h] = dims(i);
          gsap.set(el, { width: w, height: h });
        }
        gsap.set(text, { width: Math.min(T.textW * SF, T.textW) });
      };

      const intro = [layers.eyebrow, layers.h1, layers.desc];
      const states = T.introAll
        ? [intro, [layers.big]]
        : [[layers.eyebrow], [layers.eyebrow, layers.h1], intro, [layers.big]];
      let textTops = states.map(() => 0);
      const centreTop = (els) => {
        const shown = els.filter((el) => el && el.offsetHeight > 0);
        if (!shown.length) return SH / 2;
        const top = Math.min(...shown.map((el) => el.offsetTop));
        const bottom = Math.max(...shown.map((el) => el.offsetTop + el.offsetHeight));
        return (SH - (bottom - top)) / 2 - top;
      };
      const measure = () => {
        sizeCards();
        textTops = states.map(centreTop);
      };
      measure();

      const pinTop = () => parseFloat(getComputedStyle(pin).top) || 0;
      const scroller = (() => {
        const pw = document.querySelector('.page-wrapper');
        return pw && getComputedStyle(document.documentElement).overflow === 'hidden' ? pw : window;
      })();

      const ray = (i) => {
        const [hx, hy, hw, hh] = T.home[i];
        return {
          px: (hx + hw / 2) / T.figW,
          py: (hy + hh / 2) / T.figH,
        };
      };
      const homeScale = (i) => (T.cardW ? T.home[i][2] / (T.cardW * T.figW) : 1);
      const homeAt = (i) => {
        const r = ray(i);
        const [w, h] = dims(i);
        const s = homeScale(i);
        return {
          x: SW / 2 + (r.px - 0.5) * SW - (w * s) / 2,
          y: SH / 2 + (r.py - 0.5) * SH - (h * s) / 2,
        };
      };
      const posAt = (i, k) => {
        const r = ray(i);
        const [w, h] = dims(i);
        return {
          x: SW / 2 + (r.px - 0.5) * SW * k - w / 2,
          y: SH / 2 + (r.py - 0.5) * SH * k - h / 2,
        };
      };

      const lead = gsap.fromTo(text,
        { marginTop: () => -SH / 2 },
        {
          marginTop: 0,
          ease: 'none',
          scrollTrigger: {
            trigger: root,
            scroller,
            start: 'top bottom',
            end: () => `top ${pinTop()}`,
            scrub: SCRUB,
            invalidateOnRefresh: true,
          },
        });

      const tl = gsap.timeline({
        defaults: { ease: 'none' },
        scrollTrigger: {
          trigger: root,
          scroller,
          start: () => `top ${pinTop()}`,
          end: `+=${T.room}`,
          scrub: SCRUB,
          invalidateOnRefresh: true,
        },
      });

      const exitAt = (i, idx) => {
        if (!T.exitX) return posAt(i, K_OUT);
        const r = ray(i);
        const [w, h] = dims(i);
        const dir = idx % 2 === 0 ? -1 : 1;
        return {
          x: SW / 2 + dir * T.exitX * SW - w / 2,
          y: SH / 2 + (r.py - 0.5) * SH * T.yDamp - h / 2,
        };
      };

      const first = T.first ?? FIRST;
      const step = T.step ?? STEP;
      const slot = T.slot ?? SLOT_LEN;
      const present = ORDER.filter((i) => cards[i]);
      present.forEach((i, idx) => {
        const el = cards[i];
        const start = first + idx * step;
        tl.fromTo(el,
          { x: () => homeAt(i).x, y: () => homeAt(i).y, scale: () => homeScale(i), opacity: T.home[i][4], transformOrigin: 'top left' },
          { x: () => exitAt(i, idx).x, y: () => exitAt(i, idx).y, scale: SCALE_OUT, duration: slot }, start);
      });

      const S = TEXT_STEPS;
      if (T.introAll) {
        tl.fromTo(text, { top: () => textTops[0] }, { top: () => textTops[1], duration: S.bigMove[1] }, S.bigMove[0]);
        tl.fromTo(intro, { opacity: 1 }, { opacity: 0, duration: S.oldOut[1] }, S.oldOut[0]);
      } else {
        tl.fromTo(text, { top: () => textTops[0] }, { top: () => textTops[1], duration: S.h1In[1] }, S.h1In[0])
          .to(text, { top: () => textTops[2], duration: S.descIn[1] }, S.descIn[0])
          .to(text, { top: () => textTops[3], duration: S.bigMove[1] }, S.bigMove[0]);
        tl.fromTo(layers.h1, { opacity: 0 }, { opacity: 1, duration: S.h1In[1] }, S.h1In[0])
          .fromTo(layers.desc, { opacity: 0 }, { opacity: 1, duration: S.descIn[1] }, S.descIn[0])
          .to(intro, { opacity: 0, duration: S.oldOut[1] }, S.oldOut[0]);
      }
      tl.fromTo(layers.big, { opacity: 0 }, { opacity: 1, duration: S.bigIn[1] }, S.bigIn[0]);

      ScrollTrigger.addEventListener('refreshInit', measure);
      window.addEventListener('load', ScrollTrigger.refresh, { once: true });
      document.fonts?.ready.then(() => ScrollTrigger.refresh());

      return () => {
        root.classList.remove('drv-lhero--anim');
        ScrollTrigger.removeEventListener('refreshInit', measure);
        lead.scrollTrigger?.kill();
        lead.kill();
        tl.scrollTrigger?.kill();
        tl.kill();
      };
    }));

    cleanup = () => mm.revert();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', (e) => {
    if (e.target.contains(document.getElementById('DrvLearnHero'))) cleanup?.();
  });
})();
